import { GoogleCalendarIcon } from "@/components/icons/GoogleCalendarIcon.tsx";
import { OutlookIcon } from "@/components/icons/OutlookIcon.tsx";

export const getCalendarProviderLabel = (provider: string): string => {
  switch (provider) {
    case "microsoft":
      return "Outlook Calendar";
    default:
      return "Google Calendar";
  }
};

export const getCalendarProviderIcon = (provider: string, className: string) => {
  switch (provider) {
    case "microsoft":
      return <OutlookIcon className={className} />;
    default:
      return <GoogleCalendarIcon className={className} />;
  }
};
